export const USER_ROLE = {
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super Admin',
  GUEST: 'Guest',
} as const;

export const ACTIVE_STATUS = 'ACTIVE';
export const REVOKED_STATUS = 'REVOKED';
export const ADDED_STATUS = 'ADDED';

export const USER_STATUS = {
  [ACTIVE_STATUS]: ACTIVE_STATUS,
  [REVOKED_STATUS]: REVOKED_STATUS,
  [ADDED_STATUS]: ADDED_STATUS,
};

export type UserRole = keyof typeof USER_ROLE;
export type UserStatus = keyof typeof USER_STATUS;

export interface User {
  readonly id: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly avatar: string;
  readonly role: UserRole;
  readonly status: UserStatus;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface BotUsers {
  email: string;
  verified: boolean;
  isActive: boolean;
}
